import { render, staticRenderFns } from "./FundComponent.vue?vue&type=template&id=2be2f00b&"
import script from "./FundComponent.vue?vue&type=script&lang=js&"
export * from "./FundComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports